import { KycError, KycErrorType, KycProcess } from '../types';

export const isKYCProcessPending = (process: KycProcess | null) =>
  process !== null && !['NOT_INITIATED', 'COMPLETED', 'CANCELLED'].includes(process.state);

export const isKycProcessCompleted = (latestProcess: KycProcess | null) => {
  if (latestProcess === null) {
    return false;
  }
  return latestProcess.state === 'COMPLETED';
};

const KycErrorMapping: { [section in KycErrorType]: string } = {
  'document-unusable': 'compliance.kyc.errors.document-unusable',
  'no-suitable-account': 'compliance.kyc.errors.no-suitable-account',
  'no-face-detected': 'compliance.kyc.errors.no-face-detected',
  'multiple-faces-detected': 'compliance.kyc.errors.multiple-faces-detected',
  'unclear-images': 'compliance.kyc.errors.unclear-images',
  'unclear-document-image': 'compliance.kyc.errors.unclear-document-image',
  'unclear-selfie-image': 'compliance.kyc.errors.unclear-selfie-image',
  unknown: 'compliance.kyc.errors.unknown',
};

export const getErrorMessageKey = (error: KycError | null) =>
  KycErrorMapping[error?.key ?? 'unknown'] ?? 'compliance.kyc.errors.unknown';
